import React, { useState } from 'react'
import cx from 'classnames'

import BlockContent from 'src/components/global/BlockContent'

import { Serializer } from 'src/utils/serializer'
import { FAQProps } from './interfaces/FAQ'

export const Faqs = ({ data }: { data: FAQProps }) => {
  const [activeFact, setActiveFact] = useState<string | null>(null)
  const { title, cta, faqs, backgroundColor, deepLinkId } = data

  // get schema for each question and answer
  const mainEntities = faqs
    .filter(faq => faq.question)
    ?.map(faq => {
      let answerText = ''
      faq.answer.forEach(answer => {
        answer.children.forEach(child => {
          if (child.text) {
            answerText += child.text
          }
        })
      })

      return {
        '@type': 'Question',
        name: faq.question,
        acceptedAnswer: {
          '@type': 'Answer',
          text: `${answerText}`,
        },
      }
    })
    .filter(entity => entity.acceptedAnswer.text.length > 0) // Filter out empty answers

  return (
    <>
      <script key="json-ld" type="application/ld+json">
        {JSON.stringify({
          '@context': 'https://schema.org',
          '@type': 'FAQPage',
          mainEntity: mainEntities,
        })}
      </script>

      <div
        id={deepLinkId}
        className={cx('rel pys', backgroundColor, {
          cw: backgroundColor === 'bcb',
        })}
      >
        <div className="container--l mmb20 mxa outer p1">
          <h2 className="mt0 pt0">{title}</h2>
          <div className="f fw jcs mb1 pb0 ais">
            {faqs?.map(faq => (
              <div
                onClick={() =>
                  setActiveFact(activeFact === faq._id ? null : faq._id)
                }
                key={faq._id}
                className="ba rel mb1 br col-m-3 faq__single bcw cb"
              >
                <h4 className="ss20 sm21 p1 pb0 py0 m0">{faq.question}</h4>
                <div
                  className={cx('faq__answer mt0', {
                    open: activeFact === faq._id,
                  })}
                >
                  <div className="px1">
                    <BlockContent
                      blocks={faq.answer}
                      serializers={Serializer}
                    />
                  </div>
                  <div
                    className="faq__squiggle x"
                    style={{ backgroundImage: 'url(/squiggle-black.png)' }}
                  />
                  <div className="p1">
                    <button className="no-style cursor ss15 sm18 px1 py05 karla bold">
                      {activeFact === faq._id
                        ? 'Close answer +'
                        : 'See answer +'}
                    </button>
                  </div>
                </div>
                {activeFact !== faq._id && (
                  <React.Fragment>
                    <div
                      className="faq__squiggle x"
                      style={{ backgroundImage: 'url(/squiggle-black.png)' }}
                    />
                    <div className="p1">
                      <button className="no-style cursor ss15 sm18 px1 py05 karla bold">
                        {activeFact === faq._id
                          ? 'Close answer +'
                          : 'See answer +'}
                      </button>
                    </div>
                  </React.Fragment>
                )}
              </div>
            ))}
          </div>
          {cta && (
            <a
              href="https://intercom.help/ask-tia/en/"
              target="_blank"
              className="inline-block mt0 button button--transparent-b"
            >
              {cta}
            </a>
          )}
        </div>
      </div>
    </>
  )
}

export default Faqs
